import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

export const selectSigningDocumentsState = createSelector(
  (state: RootState) => state.documentSigning,
  data => ({ ...data }),
);

export const selectSigningDocuments = createSelector(
  selectSigningDocumentsState,
  state => state.signingDocs,
);
